import React from 'react';
import { Navigate } from 'react-router-dom';
import useUser from '../../hooks/useUser';

type Props = {
  children: React.ReactNode;
  requireSite?: boolean;
  fallbackTo?: string;
};

const RequireSiteScope = ({ children, requireSite = true, fallbackTo = '/dashboard' }: Props) => {
  const { loading, user, canAccessAllSites, siteId } = useUser();

  if (loading) return <div className="p-4">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;

  if (requireSite && !canAccessAllSites && !siteId && user.role !== 'SuperAdmin') {
    return <Navigate to={fallbackTo} replace />;
  }

  return <>{children}</>;
};

export default RequireSiteScope;

